var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        (function () {
            var CallBackWidget = function () {
                function CallBackWidget() {
                    _classCallCheck(this, CallBackWidget);

                    this.statusBaseClass = 'callback-widget__status';
                    this.endpoint = '/new/widget/callback-create';
                    this.defaultModalTitle = 'Оставьте заявку';
                    this.phoneMask = null;
                    this.initPhoneMask();
                }

                _createClass(CallBackWidget, [{
                    key: "init",
                    value: function init() {
                        document.addEventListener('click', this.handleClick.bind(this));
                        document.addEventListener('input', this.handleInput.bind(this));
                        document.addEventListener('submit', this.handleSubmit.bind(this));
                        this.bindCodeChangeHandlers();
                    }
                }, {
                    key: "bindCodeChangeHandlers",
                    value: function bindCodeChangeHandlers() {
                        var _this = this;

                        document.querySelectorAll('.callback-widget__code').forEach(function (codeInput) {
                            if (codeInput.dataset.callbackCodeBound === 'true') {
                                return;
                            }

                            codeInput.addEventListener('change', _this.handleChangePhoneCode.bind(_this));
                            codeInput.dataset.callbackCodeBound = 'true';
                        });
                    }
                }, {
                    key: "handleClick",
                    value: function handleClick(event) {
                        var openButton = event.target.closest('.js_callback-open');
                        var submitButton = event.target.closest('.callback-widget__submit');

                        if (openButton) {
                            this.openModal(openButton);
                            return;
                        }

                        if (!submitButton) {
                            return;
                        }

                        var modal = submitButton.closest('.callback-widget');
                        var form = modal ? modal.querySelector('.callback-widget__form') : null;

                        if (form) {
                            this.submit(form);
                        }
                    }
                }, {
                    key: "handleInput",
                    value: function handleInput(event) {
                        var phoneInput = event.target.closest('.callback-widget__phone-input');

                        if (!phoneInput) {
                            return;
                        }

                        if (this.isMaskedPhoneInput(phoneInput)) {
                            return;
                        }

                        phoneInput.value = this.formatPhone(phoneInput.value);
                    }
                }, {
                    key: "handleSubmit",
                    value: function handleSubmit(event) {
                        var form = event.target.closest('.callback-widget__form');

                        if (!form) {
                            return;
                        }

                        event.preventDefault();
                        this.submit(form);
                    }
                }, {
                    key: "handleChangePhoneCode",
                    value: function handleChangePhoneCode(event) {
                        var codeInput = event.target.closest('.callback-widget__code');

                        if (!codeInput) {
                            return;
                        }

                        var widget = codeInput.closest('.callback-widget');

                        if (!widget) {
                            return;
                        }

                        this.updatePhoneMask(widget, true);
                    }
                }, {
                    key: "openModal",
                    value: function openModal(button) {
                        var _this2 = this;

                        if (!window.modal || typeof window.modal.open !== 'function') {
                            return;
                        }

                        var modalId = button.dataset.modalId;
                        var content = document.getElementById(modalId);

                        if (!content) {
                            return;
                        }
                        this.track('book_online_callback', {
                            Place: button.dataset.place || null
                        });

                        window.modal.open({
                            header: {
                                title: 'Оставьте заявку'
                            },
                            content: { htmlDetachSelectorId: modalId },
                            parentCssClass: 'callback-widget-modal ' + (content.dataset.modalClass || ''),
                            type: window.modal.types.FLOATING,
                            footer: null,
                            onAfterShow: function onAfterShow(modal) {
                                var widget = modal ? modal.querySelector('.callback-widget') : null;

                                if (!widget) {
                                    return;
                                }

                                _this2.reset(widget);

                                var cityInput = widget.querySelector('.callback-widget__city');
                                var codeInput = widget.querySelector('.callback-widget__code');

                                _this2.syncPseudoSelect(cityInput);
                                _this2.syncPseudoSelect(codeInput);
                                _this2.bindCodeChangeHandlers();
                                _this2.updatePhoneMask(widget);
                            }
                        });
                    }
                }, {
                    key: "submit",
                    value: function submit(form) {
                        var _this3 = this;

                        var elements = this.getElements(form);
                        var payload = this.getPayload(elements);

                        if (!this.validate(elements, payload)) {
                            return;
                        }

                        this.setSubmitting(elements.submitButton, true);
                        this.setStatus(elements.statusNode, '');
                        this.track('click_send_callback_btn', { Place: payload.place });

                        this.send(payload).then(function (response) {
                            return _this3.handleResponse(elements, response);
                        }).catch(function () {
                            _this3.track('callback_create_fail', { Place: payload.place });
                            _this3.setStatus(elements.statusNode, 'Не удалось отправить заявку. Попробуйте еще раз.', 'error');
                        }).finally(function () {
                            return _this3.setSubmitting(elements.submitButton, false);
                        });
                    }
                }, {
                    key: "getElements",
                    value: function getElements(form) {
                        var modal = form.closest('.callback-widget');

                        return {
                            modal: modal,
                            submitButton: modal.querySelector('.callback-widget__submit'),
                            phoneInput: form.querySelector('.callback-widget__phone-input'),
                            cityInput: form.querySelector('.callback-widget__city'),
                            sourceInput: form.querySelector('input[name="sourceId"]'),
                            codeInput: form.querySelector('.callback-widget__code'),
                            statusNode: modal.querySelector('.callback-widget__status'),
                            formWrap: modal.querySelector('.callback-widget__form-wrap'),
                            resultWrap: modal.querySelector('.callback-widget__result')
                        };
                    }
                }, {
                    key: "getPayload",
                    value: function getPayload(elements) {
                        var code = this.normalizeCode(elements.codeInput ? elements.codeInput.value : '7');

                        return {
                            endpoint: elements.modal.dataset.endpoint || this.endpoint,
                            place: elements.modal.dataset.place || 'callback-widget',
                            cityId: elements.cityInput ? elements.cityInput.value : '',
                            code: code,
                            phone: this.getPhoneDigits(elements.phoneInput, elements.codeInput),
                            sourceId: elements.sourceInput ? elements.sourceInput.value : ''
                        };
                    }
                }, {
                    key: "validate",
                    value: function validate(elements, payload) {
                        if (!payload.cityId) {
                            this.setStatus(elements.statusNode, 'Выберите город', 'error');
                            return false;
                        }

                        var minPhoneLength = this.getMinPhoneLength(elements.codeInput);

                        if (!payload.code) {
                            this.setStatus(elements.statusNode, 'Выберите код страны', 'error');
                            return false;
                        }

                        if (payload.phone.length < minPhoneLength) {
                            this.setStatus(elements.statusNode, 'Введите корректный номер телефона', 'error');
                            return false;
                        }

                        return true;
                    }
                }, {
                    key: "send",
                    value: function send(payload) {
                        return fetch(payload.endpoint, {
                            method: 'POST',
                            credentials: 'same-origin',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                                'X-Requested-With': 'XMLHttpRequest'
                            },
                            body: this.buildBody(payload).toString()
                        }).then(function (response) {
                            return response.json();
                        });
                    }
                }, {
                    key: "buildBody",
                    value: function buildBody(payload) {
                        var body = new URLSearchParams();
                        var csrf = this.getCsrfData();

                        body.append('callbackFormData[cityId]', payload.cityId);
                        body.append('callbackFormData[code]', payload.code);
                        body.append('callbackFormData[phone]', payload.phone);
                        body.append('callbackFormData[sourceId]', payload.sourceId);
                        body.append('tourId', '');

                        if (csrf) {
                            body.append(csrf.param, csrf.token);
                        }

                        return body;
                    }
                }, {
                    key: "handleResponse",
                    value: function handleResponse(elements, response) {
                        if (response && response.success) {
                            this.track('callback_create_successfull', { Place: this.getPlace(elements) });
                            elements.formWrap.classList.add('hide');
                            elements.resultWrap.classList.remove('hide');
                            this.setModalTitle(elements.modal, elements.resultWrap.dataset.title || this.defaultModalTitle);
                            return;
                        }

                        this.track('callback_create_fail', { Place: this.getPlace(elements) });
                        this.setStatus(elements.statusNode, this.resolveError(response), 'error');
                    }
                }, {
                    key: "getPlace",
                    value: function getPlace(elements) {
                        return elements && elements.modal ? elements.modal.dataset.place || 'callback-widget' : 'callback-widget';
                    }
                }, {
                    key: "resolveError",
                    value: function resolveError(response) {
                        var defaultText = 'Не удалось отправить заявку. Попробуйте еще раз.';

                        if (!response || !response.errors) {
                            return defaultText;
                        }

                        if (response.errors.callbackForm && response.errors.callbackForm.phone) {
                            return response.errors.callbackForm.phone[0];
                        }

                        if (response.errors.callbackForm) {
                            var errorKey = Object.keys(response.errors.callbackForm)[0];

                            if (errorKey && response.errors.callbackForm[errorKey] && response.errors.callbackForm[errorKey][0]) {
                                return response.errors.callbackForm[errorKey][0];
                            }
                        }

                        var apiErrors = response.errors.apiErrors;
                        if (apiErrors && apiErrors[0] && apiErrors[0].errors) {
                            var _errorKey = Object.keys(apiErrors[0].errors)[0];
                            return apiErrors[0].errors[_errorKey];
                        }

                        return defaultText;
                    }
                }, {
                    key: "reset",
                    value: function reset(content) {
                        var formWrap = content.querySelector('.callback-widget__form-wrap');
                        var resultWrap = content.querySelector('.callback-widget__result');
                        var form = content.querySelector('.callback-widget__form');
                        var status = content.querySelector('.callback-widget__status');
                        var cityInput = content.querySelector('.callback-widget__city');
                        var codeInput = content.querySelector('.callback-widget__code');
                        var phoneInput = content.querySelector('.callback-widget__phone-input');

                        if (formWrap) {
                            formWrap.classList.remove('hide');
                        }

                        if (resultWrap) {
                            resultWrap.classList.add('hide');
                        }

                        this.setModalTitle(content, this.defaultModalTitle);

                        if (form) {
                            form.reset();
                        }

                        if (cityInput) {
                            cityInput.value = cityInput.defaultValue;
                            this.syncPseudoSelect(cityInput);
                        }

                        if (codeInput) {
                            codeInput.value = codeInput.defaultValue;
                            this.syncPseudoSelect(codeInput);
                        }

                        if (phoneInput) {
                            phoneInput.value = '';
                        }

                        this.updatePhoneMask(content);
                        this.setStatus(status, '');
                    }
                }, {
                    key: "initPseudoSelect",
                    value: function initPseudoSelect(inputId) {
                        if (!window.PseudoSelect || !inputId) {
                            return;
                        }

                        var input = document.getElementById(inputId);

                        if (!input) {
                            return;
                        }

                        var select = input.closest('.pseudo-select');

                        if (!select) {
                            return;
                        }

                        if (input.dataset.initialized === 'true') {
                            this.syncPseudoSelect(input);
                            return;
                        }

                        new window.PseudoSelect('#' + inputId);
                        input.dataset.initialized = 'true';
                        this.syncPseudoSelect(input);
                    }
                }, {
                    key: "syncPseudoSelect",
                    value: function syncPseudoSelect(input) {
                        if (!input) {
                            return;
                        }

                        var select = input.closest('.pseudo-select');

                        if (!select) {
                            return;
                        }

                        var option = select.querySelector('.options .item[data-value="' + input.value + '"]');
                        var label = select.querySelector('.sel_wrap');

                        if (!option || !label) {
                            return;
                        }

                        label.innerHTML = option.querySelector('.name') ? option.querySelector('.name').innerHTML : option.innerHTML;
                        select.querySelectorAll('.options .item').forEach(function (item) {
                            item.classList.remove('check');
                        });
                        option.classList.add('check');
                    }
                }, {
                    key: "setSubmitting",
                    value: function setSubmitting(button, isSubmitting) {
                        if (!button) {
                            return;
                        }

                        button.disabled = isSubmitting;
                        button.classList.toggle('is-loading', isSubmitting);
                    }
                }, {
                    key: "setStatus",
                    value: function setStatus(node, text, type) {
                        if (!node) {
                            return;
                        }

                        node.className = this.statusBaseClass;
                        if (type) {
                            node.classList.add('is-' + type);
                        }

                        node.textContent = text || '';
                        node.classList.toggle('hide', !text);
                    }
                }, {
                    key: "setModalTitle",
                    value: function setModalTitle(content, title) {
                        if (!content) {
                            return;
                        }

                        var modal = content.closest('.modal2');
                        var titleNode = modal ? modal.querySelector('.modal2-title') : null;

                        if (!titleNode) {
                            return;
                        }

                        titleNode.textContent = title || this.defaultModalTitle;
                    }
                }, {
                    key: "formatPhone",
                    value: function formatPhone(value) {
                        return String(value || '').replace(/\D/g, '');
                    }
                }, {
                    key: "getCsrfData",
                    value: function getCsrfData() {
                        var csrfParam = document.querySelector('meta[name="csrf-param"]');
                        var csrfToken = document.querySelector('meta[name="csrf-token"]');

                        if (!csrfParam || !csrfToken) {
                            return null;
                        }

                        return {
                            param: csrfParam.getAttribute('content'),
                            token: csrfToken.getAttribute('content')
                        };
                    }
                }, {
                    key: "track",
                    value: function track(name, properties) {
                        if (window.brxTracking && typeof window.brxTracking.sendAnalyticsEvent === 'function') {
                            window.brxTracking.sendAnalyticsEvent(name, properties || {});
                        }
                    }
                }, {
                    key: "normalizeCode",
                    value: function normalizeCode(value) {
                        return String(value || '').replace(/[^\d]/g, '');
                    }
                }, {
                    key: "getPhoneDigits",
                    value: function getPhoneDigits(phoneInput, codeInput) {
                        var digits = this.isMaskedPhoneInput(phoneInput) ? this.phoneMask.unmaskedValue : this.formatPhone(phoneInput ? phoneInput.value : '');
                        var maxLength = this.getMaxPhoneLength(codeInput);

                        return digits.slice(0, maxLength);
                    }
                }, {
                    key: "getMaxPhoneLength",
                    value: function getMaxPhoneLength(codeInput) {
                        return this.getMinPhoneLength(codeInput);
                    }
                }, {
                    key: "getMinPhoneLength",
                    value: function getMinPhoneLength(codeInput) {
                        var code = this.normalizeCode(codeInput ? codeInput.value : '');
                        var optionCodeNode = this.getCodeMetaNode(codeInput);

                        if (!optionCodeNode) {
                            return 10;
                        }

                        var totalMinLength = Number(optionCodeNode.dataset.min || 0);

                        if (!totalMinLength || !code) {
                            return 10;
                        }

                        return Math.max(totalMinLength - code.length, 1);
                    }
                }, {
                    key: "getCodeMetaNode",
                    value: function getCodeMetaNode(codeInput) {
                        if (!codeInput) {
                            return null;
                        }

                        var select = codeInput.closest('.pseudo-select');

                        if (!select) {
                            return null;
                        }

                        var option = select.querySelector('.options .item[data-value="' + codeInput.value + '"]');

                        if (!option) {
                            return null;
                        }

                        return option.querySelector('.code');
                    }
                }, {
                    key: "initPhoneMask",
                    value: function initPhoneMask() {
                        if (typeof IMask !== 'function') {
                            return;
                        }

                        var content = document.querySelector('.callback-widget');

                        if (!content) {
                            return;
                        }

                        this.updatePhoneMask(content);
                    }
                }, {
                    key: "updatePhoneMask",
                    value: function updatePhoneMask(content) {
                        var shouldResetValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                        var phoneInput = content.querySelector('.callback-widget__phone-input');
                        var codeInput = content.querySelector('.callback-widget__code');

                        if (!phoneInput || !codeInput || typeof IMask !== 'function') {
                            return;
                        }

                        var maskPattern = this.getMaskPattern(codeInput);

                        if (this.isMaskedPhoneInput(phoneInput)) {
                            this.phoneMask.updateOptions({ mask: maskPattern });
                        } else {
                            if (this.phoneMask && typeof this.phoneMask.destroy === 'function') {
                                this.phoneMask.destroy();
                            }

                            this.phoneMask = IMask(phoneInput, {
                                mask: maskPattern,
                                lazy: false,
                                overwrite: 'shift'
                            });
                        }

                        if (this.phoneMask) {
                            this.phoneMask.value = shouldResetValue ? '' : phoneInput.value || '';
                        }
                    }
                }, {
                    key: "getMaskPattern",
                    value: function getMaskPattern(codeInput) {
                        var optionCodeNode = this.getCodeMetaNode(codeInput);
                        var maskPattern = optionCodeNode ? optionCodeNode.dataset.mask : '';

                        if (!maskPattern) {
                            return '(000) 000-00-00';
                        }

                        return maskPattern.replace(/9/g, '0');
                    }
                }, {
                    key: "isMaskedPhoneInput",
                    value: function isMaskedPhoneInput(phoneInput) {
                        return Boolean(this.phoneMask && phoneInput && this.phoneMask.el && this.phoneMask.el.input === phoneInput);
                    }
                }]);

                return CallBackWidget;
            }();

            new CallBackWidget().init();
        })();
    }, {}] }, {}, [1]);